const cn_solutions = require('./cn_solutions')
const cn_products = require('./cn_products')
module.exports = {
  companyName: '全线通',
  header: {
    home: '首页',
    news: '公司新闻',
    solution: '解决方案',
    partner: '合作伙伴',
    product: '公司新闻',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    productMenu: {
      logistics: '物流运输管理',
      warehouse: '仓储管理',
      container: '集装箱管理',
      supplyChain: '供应链管理',
    },
    solutionMenu: {
      airport: '空运',
      education: '联运',
      port: '海运',
      traffic: '铁运'
    }
  },
  common: {
    learnMore: '了解更多',
    viewVideo: '观看视频'
  },
  home: {
    banner: {
      banner1Info: '走丝绸之路,创美好明天',
    },

    product: '业务模式',
    logistics: '物流运输管理',
    logisticsProject0: '端到端综合物流',
    logisticsDetail0: '纵情山河万里 肆意九州五岳',
    logisticsProject1: '国际多式联运',
    logisticsDetail1: '包括国际铁路运输、海铁联运、汽铁联运、空运等',
    logisticsProject2: '国际集装箱班列',
    logisticsDetail2: '响应“一带一路”伟大倡议,提供中欧班列境外段运营',
    logisticsProject3: '工程项目物流',
    logisticsDetail3: '针对大件、重型设备、机械、精密仪器等特殊货物',
    logisticsProject4: '国际公路运输',
    logisticsDetail4: '业务涉及中亚、西亚石油工程、化工、水利水电项目、电力工程、大型机械等运输',
    logisticsProject5: '跨境电商物流',
    logisticsDetail5: '帮助跨境电商企业增强市场竞争力',
    logisticsProject6: '国际空运运输',
    logisticsDetail6: '整机包机、半包机、个性化定制',
    logisticsProject7: '国际海运运输',
    logisticsDetail7: '主营海运集装箱货物、海运进口服务、海运散杂货运输，中港驳船等海运出口及拼箱货物',

    warehouse: '仓储管理',
    warehouseProject0: '仓储+配送+系统',
    warehouseDetail0: '海内存知己 天涯若比邻',
    warehouseProject1: '国内保税仓储',
    warehouseDetail1: '拥有自己的现代化的仓储物流中心，凭借丰富的仓储管理经验和先进的设施设备，国际标准化操作、成熟的解决方案和专业物流管理团队，为客户提供满意的仓储物流服务',
    warehouseProject2: '海外仓服务',
    warehouseDetail2: '在汉堡、华沙、莫斯科、塔什干、阿拉木图等海外城市，建立了海外仓、设置仓库管理分拨中心，并不断优化升级仓储管理服务',
    warehouseProject3: '跨境电商仓储',
    warehouseDetail3: '为跨境电商卖家提供全方位、高品质、时效稳定、性价比高的跨境物流仓储服务，助力跨境电商卖家优化供应链、降低物流成本、规避断货风险、补货无忧、产品大卖',
    warehouseProject4: '定制配送服务',
    warehouseDetail4: '为跨境电商客户提供仓储管理，订单出、入库头程，代清关及尾程最后一公里服务，为客户送货上门，全程物流跟踪信息',

    container: '集装箱管理',
    containerProject0: '有箱承运人',
    containerDetail0: '海纳百川 有容乃大',
    containerProject1: '堆场及维修服务',
    containerDetail1: '提供一站式的内陆国家集装箱租赁及堆场服务',
    containerProject2: '集装箱租赁',
    containerDetail2: '先进的信息系统提供优质高效的服务',
    containerProject3: '二手集装箱买卖',
    containerDetail3: '拥有一支经验丰富的专业集装箱服务团队',
    containerProject4: '集装箱代理运营',
    containerDetail4: '拥有多位从事一带一路管理集装箱业务的专业人员及IT管理技术骨干',

    supplyChain: '供应链管理',
    supplyChainProject0: '集装箱代理运营',
    supplyChainDetail0: '运筹帷幄之中 决胜千里之外',
    supplyChainProject1: '进出口报关',
    supplyChainDetail1: '公司取得国家商务部颁发的一级货运代理企业资质，拥有交通部颁发的“国际船舶代理”、“无船承运人”及专业（集装箱）道路运输许可等行业资质',
    supplyChainProject2: '海外销售代理',
    supplyChainDetail2: '是大陆桥（全球最大国际铁路物流行业跨境运输服务平台）协会会员也是中国国际货运协会（CIFA）会员',
    supplyChainProject3: '国内外采购代理',
    supplyChainDetail3: '公司在国内外设立了多个分支机构，可以更好的为海外客户代理采购多种优秀的“中国制造”商品',
    supplyChainProject4: '供应链金融',
    supplyChainDetail4: '提供物流、资金结算、信息处理等服务，帮助客户实现境外分销及派送，降低渠道库存，控制交易风险，加快货款回款周转率，提升客户的竞争力',

    describe: '广东全线通国际供应链有限公司坐落于中国的南大门经济特区--深圳市，公司以中欧班列为核心主营业务，涵盖中欧、中俄、中亚铁路集装箱货运、内贸铁运、海铁联运等领域。',

    coreTechnology: '业务范围',
    message1: '中欧、中亚国际联运产品：提供全国各地公司至广州、郑州、西安、成都、重庆等地，经铁路班列运往欧洲（马拉、罗兹、蒂尔堡、杜伊斯堡、汉堡、布达佩斯等城市）、中亚（阿拉木图、塔什干等城市）各国的国际多式联运物流服务；\n' +
      '\n' +
      '中俄国际联运产品：提供全国各地公司至深圳、广州、郑州、西安、成都、重庆等地，经铁路班列运往俄罗斯（全境）的国际多式联运物流服务；',


    solution: '解决方案',
    airport: '航空运输',
    apron: '航空运输',


    education: '国际联运',
    message3: '国际联运',

    port: '海上运输',
    message6: '集装箱运输',
    traffic: '铁路运输',
    message11: '中欧国际铁路运输 ',
    moreSolution: '更多方案 ',
    partner: '合作伙伴',

    mainLine: '主营线路',
    chinaRailwayExpress: '中欧班列',
    chinaRailwayExpress1: '中白俄乌',
    chinaRailwayExpress2: '俄罗斯、白俄罗斯、乌克兰',
    chinaRailwayExpress3: '中亚 南亚 西亚',
    chinaRailwayExpress4: '乌兹别克斯坦、哈萨克斯坦、吉尔吉斯斯坦、尼泊尔、伊朗、伊斯坦布尔',
    chinaRailwayExpress5: '欧洲',
    chinaRailwayExpress6: '曼海姆、布拉格、斯瓦夫库夫、帝尔堡、纽伦堡、米兰、伊明汉姆',

    seaRail: '海铁联运',
    seaRail1: '广州--宁波',
    seaRail2: '（增城西、广州国际港、南沙港）',
    seaRail3: '东莞--青岛',
    seaRail4: '（大朗港）',

    schedule: '班期',
    columnWeek: '列/周',
    aging: '时效',
    day: '天',
    hotLine: '热门路线',

    hotLine1: '增城西／南沙港／广州国际港／大朗',
    hotLine11: '果斯／山口／二连／满洲里',
    hotLine12: '俄罗斯／白俄罗斯',
    hotLine13: '线路介绍',
    hotLine14: '该线路可选择从增城西／南沙港／广州国际港／大朗出发，经过果斯／山口／二连／满洲里，最终目的地可抵达俄罗斯／白俄罗斯。',
    hotLine15: '进一步发挥“中欧班列+海港”模式效能，推进“丝绸之路经济带”与“21世纪海上丝绸之路”高效贯通，提升粤港澳大湾区与“一带一路”沿线国家贸易合作的业务规模，形成内外联动、产销衔接、优势互补、相互促进的发展格局，服务推动共建“一带一路”高质量发展。进一步简化流程，缩短运输时间，大大提高班列的时效性，全程仅10天抵达。',

    hotLine2: '西安',
    hotLine21: '果斯／山口',
    hotLine22: '俄罗斯/舒莎蕾/中亚',
    hotLine23: '线路介绍',
    hotLine24: '经由我国新疆阿拉山口或果斯出境，穿越哈萨克斯坦、俄罗斯、白俄罗斯，最终抵达波兰华沙，途经５个国家，全程9048公里，预计12天后抵达目的地。',
    hotLine25: '自2013年“一带一路”倡议提出以来，西安国际港务区充分发挥西安地理区位优势，积极探索构筑内陆国际贸易通道，于当年11月28日开通中欧班列“长安号”。目前，中欧班列“长安号”常态化开行至中亚、欧洲的干线已达15条，覆盖“一带一路”沿线45个国家和地区，构建了一条连接中亚、西亚、南亚，辐射欧洲腹地的国际物流大通道。2020年前11个月，中欧班列“长安号”共开行3441列，是去年同期的1.8倍。',

    hotLine3: '南沙港',
    hotLine31: '果斯',
    hotLine32: '中亚五国',
    hotLine33: '线路介绍',
    hotLine34: '南沙港-果斯-中亚班列具有发车时间固定、全程运行时间稳定、费用较低等特性。强调去程和回程班列往返程对开，严格计算班列换轨的衔接时间，即通过控制去程、回程班列同一时间到达换装口岸，集装箱互换车板后第一时间发运。公共班列的开行预示着中亚班列全程时效能够精准把控，全程车板利用率充分，等待时间几乎为零，全面实现高质量发展新阶段。同时大大满足市场对于中亚散货（棉纱、绿豆、面粉、初榨油、电解铜、群青、牛皮、面包、蜂蜜、大麦、麦麸、糖果、花生仁、钾肥等）的进口需求。',

    hotLine4: '成都/重庆',
    hotLine41: '果斯／山口',
    hotLine42: '欧洲／俄罗斯',
    hotLine43: '线路介绍',
    hotLine44: '从成都城厢站始发，由阿拉山口或果斯出境，途经哈萨克斯坦、俄罗斯、白俄罗斯，至波兰罗兹站，全程9965公里，运行时间约14天。货源主要是本地生产的IT产品及其它出口货物。',
    hotLine45: '渝新欧”的名称来源于沿线六个国家铁路、海关部门共同商定。“渝”指重庆，“新”指新疆阿拉山口，“欧”指欧洲，合称“渝新欧”。作为重庆市打造内陆开放高地的重要战略之一，中欧班列（渝新欧）于2011年3月正式开行。截止2022年12月初，中欧班列（渝新欧）累计开行突破20000列。',

    hotLine5: '武汉',
    hotLine51: '山口',
    hotLine52: '欧洲／俄罗斯',
    hotLine53: '线路介绍',
    hotLine54: '从武汉吴家山站始发，由经阿拉山口或果斯出境，途经哈萨克斯坦、俄罗斯、白俄罗斯到达波兰、捷克,斯洛伐克等国家的相关城市，全程10700公里左右，运行时间约15天。',
    hotLine55: '2023年中欧班列（武汉）在开行方面有了以下新变化：一是列车编组越来越长。从最初每列编组41辆，到现在每列编组增加到55辆，运量大大提升。二是开行线路越来越多。从最初中欧班列（武汉）仅有武汉至捷克帕尔杜比采一条线路，到现在中欧已拥有37条稳定的跨境运输线路，辐射欧亚大陆40个国家、107座城市，逐步形成“通道并行、多点直达”的国际物流网络体系。',

    hotLine6: '郑州',
    hotLine61: '果斯／山口',
    hotLine62: '欧洲／俄罗斯',
    hotLine63: '线路介绍',
    hotLine64: '从郑州圃田站始发，由阿拉山口或果斯出境，途经哈萨克斯坦、俄罗斯、白俄罗斯、波兰至德国汉堡站，全程10245公里，运行时间11天到15天。',
    hotLine65: '首趟郑欧国际铁路货运班列于2013年07月18日运行，开启了中原与欧洲的“陆上丝绸之路”。郑欧班列的车次为“80001次”，是全国各地发往欧洲货运班列中的“第一号”。截至2020年11月20日，郑欧班列总累计开行3745班，总累计货值155.5亿美元，货重202.04万吨，其中2020年累计开行985班。',

  },



  aboutUs: {
    us: '关于我们',
    company: '关于公司',
    news: '新闻资讯',
    contact: '联系我们',
    companyCondtion: '公司环境',
    companyActivity: '公司活动',
    logo: '全线通',

    message0: {
      message01: '广东全线通国际供应链有限公司坐落于深圳市龙华区龙华街道清湖社区雪岗北路恒博利荣丰产业园，注册资金2000万元，公司取得国家商务部颁发的一级货运代理企业资质，拥有交通部颁发的“国际船舶代理”、“无船承运人”及专业（集装箱）道路运输许可等行业资质，同时是大陆桥（全球最大国际铁路物流行业跨境运输服务平台）协会会员也是中国国际货运协会（CIFA）会员。\n' +
        '为积极响应国家“一带一路”战略决策和助推，公司专注于货物从国内到欧洲、俄罗斯、中亚各地，集有铁路、海运、空运、海铁及卡航等多式联运兼仓储一体化的综合物流服务。同时为更快、更好地与国际接轨，公司秉承“供应链管理一体化”的现代物流理念，以优质的服务赢得众多客户的信赖。\n' +
        '         公司拥有优秀的专业团队和高效快捷的操作模式，以诚信、安全、快捷、专业化为原则为客户不断优化物流各环节，降低物流成本，为国内外客户提供铁路、公路、海运及报关报检、仓储、装卸、集装箱堆存等“一站式”物流服务，为公司奠定了良好发展的基础，不断为客户提供最佳的解决方案。\n'
    },
    mission: '我们的使命',
    tip: '走丝绸之路,创美好明天',
    vision: '我们的愿景',
    tip1: '助力一带一路的物流发展',
    culture: '企业文化',

    tip2: '我们正在快速前行中',
    message1: {
      message10: '广东省副省视察工作',
      message11: '商务部辛部长视察工作',
      message12: '广东省委书记视察工作',
      message13: '全线通与中兴签约',
    },
    tip3: '我们的网络正在快速形成',
    city1: '深圳',
    add1: '中国广东省烟台市高新区蓝海路2号蓝色智谷16号楼全线通大厦',
    city2: '扬州',
    add2: '中国江苏省扬州市江都区长江西路505-1号',
    city3: '深圳',
    add3: '新加坡兴业通道2号，Vision Exchange大楼 #08-25',

    tip4: '我们随时期待与您的合作',
    cooperation: '商务合作',
    cooperation2: '人才推荐/自荐',
    phone: '联系电话',
    abus: '关注我们',
    tip5: '微信公众号二维码'
  },
  news: {
    companynews: '公司新闻',

  },
  contactUs: {
    us: '联系我们',
    company: '关于公司',
    news: '新闻资讯',
    address: '公司地址',
    contact: '联系我们',
    companyCondtion: '公司环境',
    companyActivity: '公司活动',
    logo: '全线通',

    message0: {
      message01: '广东全线通国际供应链有限公司坐落于深圳市龙华区龙华街道清湖社区雪岗北路恒博利荣丰产业园，注册资金2000万元，公司取得国家商务部颁发的一级货运代理企业资质，拥有交通部颁发的“国际船舶代理”、“无船承运人”及专业（集装箱）道路运输许可等行业资质，同时是大陆桥（全球最大国际铁路物流行业跨境运输服务平台）协会会员也是中国国际货运协会（CIFA）会员。\n' +
        '为积极响应国家“一带一路”战略决策和助推，公司专注于货物从国内到欧洲、俄罗斯、中亚各地，集有铁路、海运、空运、海铁及卡航等多式联运兼仓储一体化的综合物流服务。同时为更快、更好地与国际接轨，公司秉承“供应链管理一体化”的现代物流理念，以优质的服务赢得众多客户的信赖。\n' +
        '         公司拥有优秀的专业团队和高效快捷的操作模式，以诚信、安全、快捷、专业化为原则为客户不断优化物流各环节，降低物流成本，为国内外客户提供铁路、公路、海运及报关报检、仓储、装卸、集装箱堆存等“一站式”物流服务，为公司奠定了良好发展的基础，不断为客户提供最佳的解决方案。\n'
    },
    mission: '我们的使命',
    tip: '走丝绸之路,创美好明天',
    vision: '我们的愿景',
    tip1: '助力一带一路的物流发展',
    culture: '企业文化',

    tip2: '我们正在快速前行中',
    message1: {
      message10: '广东省副省视察工作',
      message11: '商务部辛部长视察工作',
      message12: '广东省委书记视察工作',
      message13: '全线通与中兴签约',
    },
    tip3: '我们的网络正在快速形成',
    city1: '深圳',
    add1: '深圳市龙华区龙华街道清湖社区雪岗北路恒博利荣丰产业园C座10层C1009',

    tip4: '我们随时期待与您的合作',
    cooperation: '商务合作',
    cooperation2: '人才推荐/自荐',
    phone: '联系电话',
    abus: '关注我们',
    tip5: '微信公众号二维码'
  },
  joinUs: {
    us: '加入我们',
    environment: '公司环境',
    activities: '公司活动',
    position: '招聘岗位',
    Environment: '公司环境',
    place: '办公环境',
    tip: '宽阔明亮、空间独立',
    scene: '公司展厅',
    tip1: '未来展厅、无限畅想',

    Activities: '公司活动',
    meeting: '产学研会议',
    tip2: '我们一直站在AI科技的最前沿',
    message0: {
      message01: '中国扬州第二届人工智能产业发展应用峰会',
      message02: '国际人工智能峰会',
      message03: '全线通产品发布会',
      message04: '中国扬州数字经济发展大会',
    },
    annual: '公司团建',
    tip3: '共襄盛举、走上人生巅峰',
    companyNewsTitle: '新闻资讯',
    companyNews: '公司新闻资讯',
    companyNewsTip: '我们正在快速前行中',
    message2: {
      message01: '广东省委书记书记视察工作',
      message02: '广东省副省视察工作',
      message03: '商务部辛部长视察工作',
      message04: '广东新闻联播报导全线通',
    },
  },
  bottom: {
    entry: '快速入口',
    coreTechnology: '核心技术',
    news: '公司新闻',
    solution: '解决方案',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    joinUs: '招贤纳士',
    partner: '合作伙伴',
    allVisited: '总访问量',
  },
  newSolutions: cn_solutions,
  newProducts: cn_products
}



// WEBPACK FOOTER //
// ./src/assets/utils/lang/cn.js